
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		value: {
			type: Boolean
		},
		items: {
			type: Array as ()=>ISelectItem<string>[],
			required: true
		},
		mouseX: {
			type: Number,
			required: true
		},
		mouseY: {
			type: Number,
			required: true
		},
	},
	computed: {
		isRight():boolean{
			return this.mouseX > (document.body.clientWidth / 2);
		},
		x():number {
			if (!this.isRight){
				return this.mouseX;
			}
			return document.body.clientWidth - this.mouseX;
		}
	},
	methods: {
		onInput(value:Boolean){
			this.$emit("input", value);
		},
		onClick(value:string){
			this.$emit("click", value);
		},
		onMouseDown(event:MouseEvent){
			if (event.button != 0) return;
			if (!event.target) return;
			let listRef = this.$refs.list as Vue;
			if (!listRef) return;
			let listEl = listRef.$el;
			let target = event.target as HTMLElement;
			if (!listEl.contains(target)) {
				this.onInput(false);
			}
		}
	},
	created(){
		window.addEventListener("mousedown", this.onMouseDown);
	},
	destroyed(){
		window.removeEventListener("mousedown", this.onMouseDown);
	}
});
